import React from "react";
import Typography from "@material-ui/core/Typography";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Icon from "@material-ui/core/Icon";
import Container from "@material-ui/core/Container";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    color: "white",
    backgroundColor: theme.palette.primary.dark,
    padding: "10px 20px",
    display: "flex",
    alignItems: "center",
  },

  icon: {
    fontSize: "3.5rem",
  },

  headerLabel: {
    paddingLeft: "1.5rem",
  },
}));

const PanelHeader = ({ label, icon }) => {
  const classes = useStyles();

  return (
    <Container maxWidth={false} className={classes.root}>
      {icon ? (
        <Icon fontSize="large" className={icon}>{icon}</Icon>
      ) : (
        <ChevronRightIcon className={classes.icon} />
      )}

      <Typography className={classes.headerLabel} variant="h1">
        {label}
      </Typography>
    </Container>
  );
};

export default PanelHeader;
